import { formatPrice } from './smallUtils'

/**
 * Used: S.
 */
const GENERIC = [
    { id: 'c1', displayName: 'Transaction ID' },
    { id: 'c2', displayName: 'Product ID' },
    { id: 'c3', displayName: 'SKU' },
    { id: 'c4', displayName: 'Date' },
    { id: 'c5', displayName: 'Title' },
    { id: 'c6', displayName: 'Description' },
    { id: 'c7', displayName: 'Price (£)' },
    { id: 'c8', displayName: 'Name' },
    { id: 'c9', displayName: 'Address line 1' },
    { id: 'c10', displayName: 'Address line 2' },
    { id: 'c11', displayName: 'City' },
    { id: 'c12', displayName: 'Postcode' },
    { id: 'c13', displayName: 'Country' },
    { id: 'c14', displayName: 'Mobile' },
    { id: 'c15', displayName: 'Date of confirmation' },
    { id: 'c16', displayName: 'Delivery company' },
    { id: 'c17', displayName: 'Delivery tracking number' },
    { id: 'c18', displayName: 'Delivery estimated duration (working days)' },
    { id: 'c19', displayName: 'Voucher code' },
]
const BW = [
    { id: 'c1', displayName: 'Transaction ID' },
    { id: 'c2', displayName: 'First name' },
    { id: 'c3', displayName: 'Surname' },
    { id: 'c4', displayName: 'Email' },
    { id: 'c5', displayName: 'Company' },
    { id: 'c6', displayName: 'Address line 1' },
    { id: 'c7', displayName: 'Address line 2' },
    { id: 'c8', displayName: 'Town/City' },
    { id: 'c9', displayName: 'County' },
    { id: 'c10', displayName: 'Postcode' },
    { id: 'c11', displayName: 'Country/Region' },
    { id: 'c12', displayName: 'ISBN 1' },
    { id: 'c13', displayName: 'Price' },
    { id: 'c14', displayName: 'ISBN 2' },
    { id: 'c15', displayName: 'Price' },
    { id: 'c16', displayName: 'ISBN 3' },
    { id: 'c17', displayName: 'Price' },
    { id: 'c18', displayName: 'ISBN 4' },
    { id: 'c19', displayName: 'Price' },
    { id: 'c20', displayName: 'ISBN 5' },
    { id: 'c21', displayName: 'Price' },
    { id: 'c22', displayName: 'ISBN 6' },
    { id: 'c23', displayName: 'Price' },
    { id: 'c24', displayName: 'ISBN 7' },
    { id: 'c25', displayName: 'Price' },
    { id: 'c26', displayName: 'ISBN 8' },
    { id: 'c27', displayName: 'Price' },
]
const MAGNETO = [
    { id: 'c1', displayName: 'Unique Order Ref' },
    { id: 'c2', displayName: 'Shipping Contact' },
    { id: 'c3', displayName: 'Shipping Company Name' },
    { id: 'c4', displayName: 'Shipping Address 1' },
    { id: 'c5', displayName: 'Shipping Address 2' },
    { id: 'c6', displayName: 'Shipping Address 3' },
    { id: 'c7', displayName: 'Shipping City' },
    { id: 'c8', displayName: 'Shipping County' },
    { id: 'c9', displayName: 'Shipping Post Code' },
    { id: 'c10', displayName: 'Shipping Country Code' },
    { id: 'c11', displayName: 'Email Address' },
    { id: 'c12', displayName: 'Telephone' },
    { id: 'c13', displayName: 'Product Code' },
    { id: 'c14', displayName: 'Product Description' },
    { id: 'c15', displayName: 'Quantity' },
    { id: 'c16', displayName: 'Price' },
    { id: 'c17', displayName: 'Shipping Cost' },
    { id: 'c18', displayName: 'Total Order Value' },
    { id: 'c19', displayName: 'Currency Code' },
    { id: 'c20', displayName: 'Shipping Method' },
    { id: 'c21', displayName: 'Notes' },
]
const TBM = [
    { id: 'c1', displayName: 'Order_number' },
    { id: 'c2', displayName: 'Part_number' },
    { id: 'c3', displayName: 'Qty' },
    { id: 'c4', displayName: 'Unit_price' },
    { id: 'c5', displayName: 'Currency' },
    { id: 'c6', displayName: 'Shippingservice' },
    { id: 'c7', displayName: 'WarehouseCode' },
    { id: 'c8', displayName: 'Ship_to_contact_name' },
    { id: 'c9', displayName: 'Ship_to_street_1' },
    { id: 'c10', displayName: 'Ship_to_street_2' },
    { id: 'c11', displayName: 'Ship_to_city' },
    { id: 'c12', displayName: 'Ship_to_state' },
    { id: 'c13', displayName: 'Ship_to_zip' },
    { id: 'c14', displayName: 'Ship_to_country' },
    { id: 'c15', displayName: 'Ship_to_phone' },
    { id: 'c16', displayName: 'Email' },
    { id: 'c17', displayName: 'RetailerID' },
    { id: 'c18', displayName: 'Instructions' },
]
const LIST_OF_SUPPLIER_ORDER_TEMPLATES = {
    'Generic (all fields)': GENERIC,
    BW: BW,
    Magento: MAGNETO,
    TBM: TBM,
}

export const listOfSupplierOrderTemplates = Object.keys(LIST_OF_SUPPLIER_ORDER_TEMPLATES)
export const getSupplierOrderTemplateHeader = exportFormat =>
    LIST_OF_SUPPLIER_ORDER_TEMPLATES[exportFormat] || []

export const getSupplierOrderTemplateBody = (exportFormat, transactionsToExport) => {
    switch (exportFormat) {
        case 'Generic (all fields)':
            return transactionsToExport.map(
                ({
                    address,
                    date,
                    dateOfConfirmation,
                    deliveryCompany,
                    deliveryEstimatedDuration,
                    deliveryTrackingNumber,
                    price,
                    priceDescription,
                    productId,
                    sku,
                    title,
                    transactionId,
                    voucherCode,
                }) => ({
                    c1: transactionId,
                    c2: productId,
                    c3: sku,
                    c4: date,
                    c5: title,
                    c6: priceDescription,
                    c7: formatPrice(price, false),
                    c8: address.name,
                    c9: address.firstLine,
                    c10: address.secondLine,
                    c11: address.city,
                    c12: address.postcode,
                    c13: address.country,
                    c14: address.mobile,
                    c15: dateOfConfirmation,
                    c16: deliveryCompany,
                    c17: deliveryTrackingNumber,
                    c18: deliveryEstimatedDuration,
                    c19: voucherCode,
                })
            )

        case 'BW':
            return transactionsToExport.map(({ address, price, sku, transactionId }) => ({
                c1: transactionId,
                c2: address.name.split(' ')[0] || address.name,
                c3: address.name.split(' ')[1] || address.name,
                c4: 'n/a',
                c5: '',
                c6: address.firstLine,
                c7: address.secondLine === 'n/a' ? '' : address.secondLine,
                c8: address.city,
                c9: '',
                c10: address.postcode,
                c11: address.country || 'United Kingdom',
                c12: sku,
                c13: formatPrice(price, false),
                c14: '',
                c15: '',
                c16: '',
                c17: '',
                c18: '',
                c19: '',
                c20: '',
                c21: '',
                c22: '',
                c23: '',
                c24: '',
                c25: '',
                c26: '',
                c27: '',
            }))

        case 'Magento':
            return transactionsToExport.map(
                ({ address, price, priceDescription, productId, title, transactionId }) => ({
                    c1: transactionId,
                    c2: address.name,
                    c3: '',
                    c4: address.firstLine,
                    c5: address.secondLine,
                    c6: '',
                    c7: address.city,
                    c8: '',
                    c9: address.postcode,
                    c10: address.country,
                    c11: 'n/a',
                    c12: address.mobile,
                    c13: productId,
                    c14: `${title}: ${priceDescription}`,
                    c15: 1,
                    c16: price,
                    c17: '',
                    c18: price,
                    c19: 'GBP',
                    c20: '',
                    c21: '',
                })
            )

        case 'TBM':
            return transactionsToExport.map(({ address, price, productId, transactionId }) => ({
                c1: transactionId,
                c2: productId,
                c3: 1,
                c4: price,
                c5: 'GBP',
                c6: 'DUBUPSSTA',
                c7: 'DB1',
                c8: address.name,
                c9: address.firstLine,
                c10: address.secondLine,
                c11: address.city,
                c12: '',
                c13: address.postcode,
                c14: address.country,
                c15: address.mobile,
                c16: 'n/a',
                c17: '',
                c18: '',
            }))
    }
}
